export enum PaymentProcessEnum {
  Deposit = 1,
  Withdrawal = 2,
  Transfer = 3,
  Adjustment = 4
}
